import React, { PureComponent } from 'react'
import { is } from 'immutable'
import withPartials from 'react-component-with-partials'
import { isURL } from 'validator'
import Input from 'shared-web/src/components/Input'
import { Subsection, Row } from 'components/settings/UserProfile/Section'

const BIO_PLACEHOLDER = `Help others learn more about you by writing a great bio.

Here’s a couple tips: be relatable and unique! What are some things that aren’t on your resume, things that make you… well, you! This is your space, so go for it!`

class DetailInfo extends PureComponent {
  render() {
    const { detailsUI, partial } = this.props
    return (
      <Subsection title="Details"
                  isValid={this.isValid()}
                  canSubmit={this.canSubmit()}
                  onSubmit={this.handleSave}
                  onCancel={this.handleCancel}
      >
        <div className="profile-settings">
          <Row>
            <div className="profile-settings-container">
              <div className="profile-settings-left">
                <div className="dsg-Label">Extended bio</div>
                <Input
                  size="small"
                  placeholder={BIO_PLACEHOLDER}
                  value={detailsUI.bio}
                  onChange={partial(this.handleChange, 'bio')}
                  isValid={true}
                  isTextArea={true}
                  className="profile-settings-extended-bio"
                />
              </div>
              <div className="profile-settings-right">
                <div className="profile-settings-item">
                  <div className="dsg-Label">Interests</div>
                  <Input size="small"
                         placeholder="What do you like?"
                         value={detailsUI.likes}
                         onChange={partial(this.handleChange, 'likes')}
                         isValid={true}
                  />
                </div>
                <div className="profile-settings-item">
                  <div className="dsg-Label">Fun fact</div>
                  <Input size="small"
                         placeholder="Got a hidden talent?"
                         value={detailsUI.funFact}
                         onChange={partial(this.handleChange, 'funFact')}
                         isValid={true}
                  />
                </div>
                <div className="profile-settings-item">
                  <div className="dsg-Label">Education</div>
                  <Input size="small"
                         placeholder="School of Hard Knocks ’88"
                         value={detailsUI.educationInfo}
                         onChange={partial(this.handleChange, 'educationInfo')}
                         isValid={true}
                  />
                </div>
                <div className="profile-settings-item">
                  <div className="dsg-Label">Blog URL</div>
                  <Input size="small"
                         placeholder="www.example.com"
                         value={detailsUI.blogUrl}
                         onChange={partial(this.handleChange, 'blogUrl')}
                         isValid={this.isValidUrl(detailsUI.blogUrl)}
                  />
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <div className="profile-settings-left">
              <div className="dsg-Label">Languages</div>
              <Input size="small"
                     placeholder="e.g. English, Spanish, Chinese"
                     value={detailsUI.languages}
                     onChange={partial(this.handleChange, 'languages')}
                     isValid={true}
              />
            </div>
            <div className="profile-settings-right">
              <div className="dsg-Label">Podcast URL</div>
              <Input size="small"
                     value={detailsUI.podcastUrl}
                     placeholder="www.example.com"
                     onChange={partial(this.handleChange, 'podcastUrl')}
                     isValid={this.isValidUrl(detailsUI.podcastUrl)}
              />
            </div>
          </Row>
        </div>
      </Subsection>
    )
  }

  handleChange = (key, event) => {
    const { value } = event.target
    this.props.actions.setProfileUIData({ key, value })
  }

  handleSave = () => {
    if (!this.canSubmit()) return

    this.props.actions.updateDetails()
  }

  handleCancel = () => {
    this.props.actions.setProfileUI(this.props.details)
  }

  canSubmit() {
    return !is(this.props.detailsUI, this.props.details)
  }

  isValid() {
    const { podcastUrl, blogUrl } = this.props.detailsUI

    return this.isValidUrl(podcastUrl) && this.isValidUrl(blogUrl)
  }

  isValidUrl(url) {
    if (url && url.length > 0) {
      return isURL(url)
    }

    return true
  }
}

export default withPartials(DetailInfo)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/DetailInfo/index.js